var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-skeleteonCardHorizontal"},_vm._l((12),function(i){return _c('div',[_c('div',[_c('v-sheet',{staticClass:"pa-3",attrs:{"color":`grey ${_vm.theme.isDark ? 'darken-2' : 'lighten-4'}`}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":"300","type":"card-avatar, actions"}})],1)],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }